<template>
    <div class="buttons has-addons">
        <button class="button" @click="changeStatus('DRAFT')"
            :class="[currentFD.status == 'DRAFT' ? 'is-selected is-info' : '']">DRAFT</button>
        <button class="button" @click="changeStatus('LIVE')"
            :class="[currentFD.status == 'LIVE' ? 'is-selected is-primary' : '']">LIVE</button>
        <button class="button" @click="changeStatus('CLOSED')"
            :class="[currentFD.status == 'CLOSED' ? 'is-selected is-danger' : '']">CLOSED</button>
    </div>

    <div v-if="!!error" class="notification is-danger">
        <p>{{ error }}</p>
    </div>

    <div v-if="validationErrors.length" class="block notification is-danger is-light">
        <p>
            Status couldn't be changed because of the following reason(s):
        <ul>
            <b>
                <li v-for="validationError in validationErrors" :key="validationError">{{ validationError }}</li>
            </b>
        </ul>
        </p>
    </div>

    <div class="modal" :class="[showAlert ? 'is-active' : '']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Are you sure?</p>
                <button @click="closeAlert" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="content" v-if="this.newStatus == 'DRAFT'">
                    <p>You are changing the status to DRAFT.</p>
                    <p>Which means...</p>
                    <h5>Volunteers</h5>
                    <ul>
                        <li>can sign-up if there are slots available</li>
                        <li>will NOT be able to see their teams and deliveries</li>
                    </ul>
                    <h5>Admins</h5>
                    <ul>
                        <li>can change Team numbers</li>
                        <li>can change Assignments of deliveries to the Teams</li>
                        <li>cannot take Self Collection attendance</li>
                    </ul>
                </div>
                <div class="content" v-if="this.newStatus == 'LIVE'">
                    <p>You are changing the status to LIVE.</p>
                    <p>Which means...</p>
                    <h5>Volunteers</h5>
                    <ul>
                        <li>cannot sign-up anymore</li>
                        <li>can see their teams and deliveries</li>
                        <li>can update deliveries</li>

                    </ul>
                    <h5>Admins</h5>
                    <ul>
                        <li>cannot change Team numbers</li>
                        <li>cannot change Assignments of deliveries to the Teams</li>
                        <li>can take Self Collection attendance</li>
                    </ul>
                </div>
                <div class="content" v-if="this.newStatus == 'CLOSED'">
                    <p>You are changing the status to CLOSED. </p>
                    <p>Which means...</p>
                    <ul>
                        <li>FD can't be changed anymore</li>
                        <li>Volunteers cannot see their teams and deliveries anymore</li>
                        <li>Admins cannot make any changes in the deliveries anymore</li>
                    </ul>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button @click="proceedToChange" :class="[isLoading ? 'is-loading' : '']"
                    class="button is-success">Proceed to change</button>
                <button @click="closeAlert" class="button">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            isFormValid: true,
            validationErrors: [],
            error: null,
            showAlert: false,
            newStatus: null
        }
    },
    methods: {
        async changeStatus(status) {
            if (this.currentFD.status != status) {
                this.newStatus = status;
                this.validateForm(status);
                if (this.isFormValid) {
                    this.changeAlert(status);
                }
            } else {
                this.validationErrors = [];
            }
        },
        validateForm(status) {
            this.isFormValid = false;
            this.validationErrors = [];
            if (this.currentFD.status == 'DRAFT') {
                if (status == 'LIVE') {
                    if (!this.currentFD.deliveries_generated) {
                        this.validationErrors.push("Deliveries are not generated.");
                    }
                    if (!this.currentFD.deliveries_assigned_to_teams) {
                        this.validationErrors.push("Deliveries are not assigned to the delivery teams.");
                    }
                }
                else if (status == 'CLOSED') {
                    this.validationErrors.push("Status can't be changed from DRAFT to CLOSED.")
                }
            }
            else if (this.currentFD.status == 'CLOSED') {
                this.validationErrors.push("Once closed, FD status can't be changed.")
            }
            if (!this.validationErrors.length) {
                this.isFormValid = true;
            }
        },
        changeAlert(status) {
            if (this.currentFD.status == 'DRAFT') {
                if (status == 'LIVE') {
                    this.showAlert = true;
                }
            }
            else if (this.currentFD.status == 'LIVE') {
                if (status == 'DRAFT') {
                    this.showAlert = true;
                }
                else if (status == 'CLOSED') {
                    this.showAlert = true;
                }
            }
        },
        closeAlert() {
            this.showAlert = false;
        },
        async proceedToChange() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('fd/changeFDStatus', {
                    fdID: this.currentFD.id,
                    status: this.newStatus
                });
            } catch (error) {
                this.error = error.message || "Something went wrong!";
                console.log(error);
            }
            this.isLoading = false;
            this.showAlert = false;
        }
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        }
    }
}
</script>

<style scoped>
.buttons {
    justify-content: center;
}
</style>